import configureStoreDev from "./configureStore.dev.js";
import configureStoreProd from "./configureStore.prod.js";

const configureStore =
  import.meta.env.MODE === "production"
    ? configureStoreProd
    : configureStoreDev;

export default configureStore;
